import { createRouter, createWebHistory } from 'vue-router'
import Beranda from '../views/Beranda.vue'
import berita from '../views/berita.vue'
import foto from '../views/foto.vue'
import video from '../views/video.vue'
import tema from '../views/tema.vue'
import ikm from '../views/ikm.vue'
import berita_brida from '../views/berita_brida.vue'
import artikel from '../views/artikel.vue'
import publikasi from '../views/publikasi.vue'
import krenova from '../views/krenova.vue'
import data_krenova from '../views/data_krenova.vue'
import data_riset from '../views/data_riset.vue'
import data_aksi from '../views/data_aksi.vue'
import data_teknologi from '../views/data_teknologi.vue'
import data_penelitian from '../views/data_penelitian.vue'
import data_iid from '../views/data_iid.vue'
import data_ipkd from '../views/data_ipkd.vue'
import data_idsd from '../views/data_idsd.vue'
import data_haki from '../views/data_haki.vue'
import data_tema from '../views/data_tema.vue'
import data_ikm from '../views/data_ikm.vue'
import dokumen from '../views/dokumen.vue'

const routes = [
  {
    path: '/',
    name: 'beranda',
    component: Beranda
  },
  {
    path: '/tentang',
    name: 'tentang',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/tentang.vue')
    }
  },
  {
    path: '/berita',
    name: 'berita',
    component: berita
  },
  {
    path: '/dokumen',
    name: 'dokumen',
    component: dokumen
  },
  {
    path: '/tema',
    name: 'tema',
    component: tema
  },
  {
    path: '/foto',
    name: 'foto',
    component: foto
  },
  {
    path: '/video',
    name: 'video',
    component: video
  },
  {
    path: '/berita_brida/:id',
    name: 'berita_brida',
    component: berita_brida
  },
  {
    path: '/artikel',
    name: 'artikel',
    component: artikel
  },
  {
    path: '/publikasi',
    name: 'publikasi',
    component: publikasi
  },
  {
    path: '/krenova',
    name: 'krenova',
    component: krenova
  },
  {
    path: '/data_krenova',
    name: 'data_krenova',
    component: data_krenova
  },
  {
    path: '/data_riset',
    name: 'data_riset',
    component: data_riset
  },
  {
    path: '/data_aksi',
    name: 'data_aksi',
    component: data_aksi
  },
  {
    path: '/data_teknologi',
    name: 'data_teknologi',
    component: data_teknologi
  },
  {
    path: '/data_penelitian',
    name: 'data_penelitian',
    component: data_penelitian
  },
  {
    path: '/data_iid',
    name: 'data_iid',
    component: data_iid
  },
  {
    path: '/data_ipkd',
    name: 'data_ipkd',
    component: data_ipkd
  },
  {
    path: '/data_idsd',
    name: 'data_idsd',
    component: data_idsd
  },
  {
    path: '/data_haki',
    name: 'data_haki',
    component: data_haki
  },
  {
    path: '/data_tema',
    name: 'data_tema',
    component: data_tema
  },
  {
    path: '/data_ikm',
    name: 'data_ikm',
    component: data_ikm
  },
  {
    path: '/ikm',
    name: 'ikm',
    component: ikm
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
